import React, { useState, useEffect } from "react";
import axios from 'axios';
import { useNavigate, useParams } from "react-router-dom";
import './UpdateAdminiUpdate.css'

function UpdateAdminiUpdate() {
    const { id } = useParams();
    const [name, setName] = useState('');
    const [position, setPosition] = useState('');
    const [acadStanding, setAcadStanding] = useState('');
    const [headOf, setHeadOf] = useState('');
    const [image, setImage] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        axios.get(`https://school-web-server-eight.vercel.app/getUser/${id}` )
            .then(result => {
                const {name, position, acadStanding, headOf, image} = result.data;
                console.log(result.data);
                setName(name);
                setPosition(position);
                setAcadStanding(acadStanding);
                setHeadOf(headOf);
                setImage(image);
            })
            .catch(err => console.log(err));
    }, [id]);

    const Update = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('name', name);
        formData.append('position', position);
        formData.append('acadStanding', acadStanding);
        formData.append('headOf', headOf);
        if (image instanceof File) {
            formData.append('image', image);
        }

        axios.put("https://school-web-server-eight.vercel.app/updateAdmini/" + id, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(result => {
                console.log(result);
                navigate('/login/updateadministrator');
            })
            .catch(err => console.log("error in update method" + err));
    }

    const inputImageChange = (e) => {
        setImage(e.target.files[0]);
    }

    return (
        <div className='UpdateAdminiUpdate'>
            <div className='form-update-admini'>
                <form onSubmit={Update}>
                    <h2>Update User</h2>
                    <div className='mb-2'>
                        <label htmlFor="">Picture</label>
                        <input type="file" accept='image/*' className='form-control'
                            onChange={inputImageChange} />
                    </div>
                    <div className='mb-2'>
                        <label htmlFor="">Name</label>
                        <input type="text" placeholder='Enter Name' className='form-control'
                            value={name} onChange={(e) => setName(e.target.value)} />
                    </div>
                    <div className='mb-2'>
                        <label htmlFor="">Position</label>
                        <input type="text" placeholder='Enter Position' className='form-control'
                            value={position} onChange={(e) => setPosition(e.target.value)} />
                    </div>
                    <div className='mb-2'>
                        <label htmlFor="">Academic Standing</label>
                        <input type="text" placeholder='Enter Academic Standing' className='form-control'
                            value={acadStanding} onChange={(e) => setAcadStanding(e.target.value)} />
                    </div>
                    <div className='mb-2'>
                        <label htmlFor="">Head Of</label>
                        <input type="text" placeholder='Enter Head Of' className='form-control'
                            value={headOf} onChange={(e) => setHeadOf(e.target.value)} />
                    </div>
                    <button className='btn btn-success'>Update</button>
                </form>
            </div>
        </div>
    )
}

export default UpdateAdminiUpdate;